import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=340fa25c&scoped=true&"
import script from "./Rooms.vue?vue&type=script&lang=js&"
export * from "./Rooms.vue?vue&type=script&lang=js&"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=340fa25c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340fa25c",
  null
  
)

export default component.exports